module.exports = __webpack_public_path__ + "static/media/helpdesk.d6028178.png";